import { createSlice } from '@reduxjs/toolkit'

export const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState: {
    data: [],
  },
  reducers: {
    setPortfolio: (state, action) => {
      state.data = action.payload.data
    },
    getUserPortfolio: (state, action) => {
      return state.data
    }
  },
})

export const { setPortfolio, getUserPortfolio } = portfolioSlice.actions
export const selectPortfolio = (state) => state.portfolio
export default portfolioSlice.reducer
